<template>
    <div class="p-3">
        <form-modal
            id="custos"
            placeholder-button="Inserir" 

            title-modal="Custos próprios"

            :fields="colunas"
            :values="dados"

            ref="modalForm"

            :create="permissao.c"
            :read="permissao.r"
            :update="permissao.u"
            :remove="permissao.d"

            controles

            @ok="salvar"
            @edit="editar"
            @remove="deletar"
            @cancel="fechar"
        >
            <template #modal>                
                <modal :form="form" ref="modal"  @downloadArquivo="downloadArquivo"/>
            </template>            
        </form-modal>
    </div>
</template>
<script>
import FormModal from "@/components/modal/FormModal";
import cloneDeep from "lodash/cloneDeep";
import MovimentacaoFinanceiraService from "@/common/services/movimentacao_financeira/movimentacao_financeira.service";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import helpers from "@/common/utils/helpers";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import Modal from "./modal";
export default {
    mixins: [AlertasMixin],
    components: {
        FormModal,
        Modal,
    },
    props: {
        projetoId: {
            required: true
        },
        dados : {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        form : {
            data : '',
            valor : 0,
            rubrica : '',
            conteudoBase64 : '',
            nomeArquivo : '',
        },
        colunas : [
            {key : "data", label : "Data de emissão ou despesa",
                formatter : (value) => helpers.formatarDataBr(value)
            },
            {key : "rubrica", label : "Rubrica",
                formatter : (value) => helpers.getEnum(value).text
            },                       
            {key : "valor", label : "Valor",
                formatter : (value) => helpers.formatarValor(value)
            },
            {key : "actions", label : "Ações"},
        ],
    }),
    mounted(){
    },
    methods : {
        fechar : function(){
            this.form = {
                data : '',
                valor : 0,
                rubrica : '',
                notaFiscalBase64 : '',
                nomeArquivo : '',
            };
            this.buscar();
        },
        adicionar : function(){
            this.$refs.modalForm.openModal();
        },
        buscar : function(){
            this.$emit('update');
        },
        montar : function(){
            
        },
        salvar : function(){
            let form = cloneDeep(this.form);
            if(!this.$refs.modal.validateState())
                return;

            this.confirmar('Aviso','Deseja salvar?').then(confirmado => {
                if(confirmado){

                    form.projetoRN316Id = this.projetoId;
                    form.valor = helpers.removerValor(form.valor);

                    if(form.nomeArquivoAWSUP != null){
                        form.nomeArquivoAWS = form.nomeArquivoAWSUP;
                        delete form["nomeArquivoAWSUP"];
                    }

                    this.$store.dispatch(START_LOADING);
                    MovimentacaoFinanceiraService.salvarCustoRN316(form).then(() => {
                        this.alertaSucesso('Salvo com sucesso!').then(() => {
                            this.$refs.modalForm.closeModal();
                            this.buscar();
                        });
                    }).catch(err => {
                         if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else   
                            this.alertaErro("Erro ao salvar");
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            })
        },

        deletar : function(item){
            this.confirmar('Aviso','Deseja realmente excluir?').then(confirmado => {
                if(confirmado){

                    this.$store.dispatch(START_LOADING);
                    MovimentacaoFinanceiraService.excluirCustoRN316(item.id).then(() => {
                        this.alertaSucesso('Excluído com sucesso!');
                        this.buscar();
                    }).catch(err => {
                         if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else   
                            this.alertaErro("Erro ao excluir");
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            })
        },

        editar : function(item){
            let form = cloneDeep(item);
            this.form = form;
            this.form.data = helpers.formatarDataBr(this.form.data);
            this.form.valor = helpers.formatarValor(this.form.valor);
            this.$refs.modalForm.openModal();
        },

        downloadArquivo : function(id){
            this.$store.dispatch(START_LOADING);

            MovimentacaoFinanceiraService.downloadCustoRN316(id)
            .then(response => {
                helpers.baixarArquivo(response.data, response.headers);
                this.alertaSucesso("Download do Arquivo Concluido!");               
            }).catch(err => {
                console.log(err);
                this.alertaErro("Erro ao fazer Download do Arquivo");
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
    },
    computed : {
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosRn316Custos');
        },
    }
}
</script>
<style lang="">
    
</style>